// F5: the answer to the front page's Browse call that index.html started before the app's code arrived
// (app/early-browse.js). Taken at most once, and only when it is exactly the call the app is about to make: the same
// request body, the same session token, and started within the last 30 s. Anything else returns null and the app
// asks the normal way, so a stale or someone else's answer can never be shown.
type Early = { key: string; token: string; at: number; res: Promise<unknown> }
declare global {
  interface Window { __mgEarlyBrowse?: Early }
}

/** No imports on purpose (tests/early_browse_test.ts runs it under Deno); the caller names the answer's type. */
export function takeEarlyBrowse<T>(key: string, token: string | null): Promise<T | null> | null {
  const w = globalThis as unknown as Window
  const e = w.__mgEarlyBrowse
  if (!e) return null
  w.__mgEarlyBrowse = undefined
  if (e.key !== key || !token || e.token !== token || Date.now() - e.at > 30000) return null
  return e.res as Promise<T | null>
}

/** The first run is about to run in this load: whatever was fetched early answers for the profile before it. */
export function dropEarlyBrowse() {
  ;(globalThis as unknown as Window).__mgEarlyBrowse = undefined
}
